import React, { useState } from 'react';
import './App.css';
import Alert from './components/Alert';
import About from './components/About';
import Navbar from './components/Navbar';
import TextForm from './components/TextForm';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

function App() {
  const [mode, setMode] = useState('light'); //Whether the dark mode is enabled or not
  const [alert, setAlert] = useState(null); //this is to set the value of the alert message

  const showAlert = (message, type) => {
    // this is to show the alert message or we can say that to trigger the alert message
    // type is the type of alert as per the bootstrap
    setAlert({
      msg: message,
      type: type
    })
    setTimeout(() => {
      setAlert(null);
    }, 3000);
    // This will dismiss the alert in 3s, this is a timeout function 
  }

  const toggleMode = () => {
    if (mode === 'light') {
      setMode('dark');
      document.body.style.backgroundColor = '#404040';
      document.body.style.color = 'white';
      showAlert("Dark mode is enabled!!!", "success");
      // setInterval(() => {
      //   document.title = 'TextUtils is Amazing!!!'
      // }, 2000);
      // setInterval(() => {
      //   document.title = 'Install textUtils now!!!'
      // }, 1500);
    } else {
      setMode('light');
      document.body.style.backgroundColor = 'white';
      document.body.style.color = '#404040';
      showAlert("Light mode is enabled!!!", "success");
    }
  }

  return (
    <Router>
      <Navbar title="TextUtils" aboutText="About Us" mode={mode} toggleMode={toggleMode} />
      <Alert alert={alert} />
      <div className="container my-3">
        <Routes>
          <Route exact path='/about' element={<About mode={mode}/>} />
          <Route exact path='/' element={<TextForm showAlert={showAlert} heading="Enter the text to analyse" />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
